export const getByUuid = (axios, payload) => axios.post(`formulario-prontuario/get/uuid`, payload)

export const updateByUuid = (axios, payload) => axios.patch(`formulario-prontuario`, payload)